import { render } from "./instructor-sidebar.vue?vue&type=template&id=33408cf5"
import script from "./instructor-sidebar.vue?vue&type=script&lang=js"
export * from "./instructor-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__